module.exports = __webpack_public_path__ + "static/img/8areaA_11.26d6c24.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_11.png
// module id = 1065
// module chunks = 1